import { render, staticRenderFns } from "./BillingPlanPayersEditList.vue?vue&type=template&id=25e5ccc8&scoped=true"
import script from "./BillingPlanPayersEditList.vue?vue&type=script&lang=js"
export * from "./BillingPlanPayersEditList.vue?vue&type=script&lang=js"
import style0 from "./BillingPlanPayersEditList.vue?vue&type=style&index=0&id=25e5ccc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e5ccc8",
  null
  
)

export default component.exports